import { ClientService, ToastMessageService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { TENANTSINTERFACE } from '@fitness-force/models';
import { DateFormatedComponent } from 'libs/grid-utility/src/lib/date-formated/date-formated.component';
import { TenantNameComponent } from '../../data-grid/utility/tenant/tenant-name/tenant-name.component';
import { StaffInfoComponent } from '../../staff/staff-info/staff-info.component';
import { DataGridComponent } from 'libs/grid/src/lib/data-grid/data-grid.component';
import { EmptyStateContainerComponent } from '@fitness-force/grid';
@Component({
  selector: 'client-history',
  templateUrl: './client-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    StyleClassModule,
    TranslateModule,
    DataGridComponent
  ]
})
export class ClientHistoryComponent implements OnInit {
  @Input() clientHistoryModal: boolean | null = false;
  @Input() clientData$ = new BehaviorSubject<any>(null);
  @Output() closeClientHistoryDialog = new EventEmitter();
  allClientData$ = new BehaviorSubject<any>({});
  clientData: any;
  allTenants$ = new BehaviorSubject<any>([]);
  isloading:boolean=false;
  tenantId: number = 0;
  claims: string[] = ['can_be_client_rep'];
  tableData= new BehaviorSubject<any[]>([]);
  tableColumns= new BehaviorSubject<any[]>([]);
  emptyStateComponent= new BehaviorSubject<any>(EmptyStateContainerComponent);

  constructor(private store: Store, 
     public translate: TranslateService,
     private clientService: ClientService,
     public toastMessageService: ToastMessageService,
     private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.componentInit()
  }

  componentInit() {
    this.clientData$.subscribe(
      (client: any) => {
        this.allClientData$.next(client)
        this.clientData = client
        this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
          this.tenantId = tenant.selected_tenant.id;
          this.allTenants$.next(tenant.accessed_tenant);
          this.getClientHistory()
        });
      })
  }

  getClientHistory() {
    this.isloading = true;
    this.clientService.getClientHistory(this.clientData.id).subscribe({
      next: (res: any) => {
        this.tableData.next(res.items);
        this.columnTranslate();
        this.isloading = false;
      },
      error: (error: any) => {
        this.tableData.next([]);
        this.columnTranslate()
        this.isloading = false;
      },
      complete: () => {
        this.isloading = false;
        this.cd.detectChanges();
      }
    })
  }

  columnTranslate() {
    this.translate
      .get([
        'Shared.PROSPECT.MORE_FILTERS.DATE',
        'REFUND.TENANT',
        'Shared.PROSPECT.MORE_FILTERS.CHANNEL',
        'Shared.PROSPECT.MORE_FILTERS.SOURCE',
        'CreateEditStaff.SPAN_STAFF',
        'TRANSFER.COMMENTS'
      ])
      .subscribe((translations) => {
        this.setColumnTranslate(translations);
      });
  }

  setColumnTranslate(translations: any) {
    var column = {
      DateTime: translations['Shared.PROSPECT.MORE_FILTERS.DATE'],
      Tenant: translations['REFUND.TENANT'],
      Channel: translations['Shared.PROSPECT.MORE_FILTERS.CHANNEL'],
      Source: translations['Shared.PROSPECT.MORE_FILTERS.SOURCE'],
      Staff: translations['CreateEditStaff.SPAN_STAFF'],
      Comments: translations['TRANSFER.COMMENTS'],
    };
    this.tableColumns.next([
      {
        title: column.DateTime,
        classes: 'py-3 white-space-nowrap align-items-center uppercase',
        dataProperty: 'prospect_effective_date',
        type: 'component',
        data: {
          name: DateFormatedComponent, additionData: true, aData: { KeyName: 'prospect_effective_date', format: 'datetime',applytimezone:true }
        },
      },
      {
        title: column.Tenant,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'tenant_id',
        type: 'component',
        data: {
          name: TenantNameComponent,
          additionData: true,
          aData: { fetch_key: 'tenant_id' },
        }      
      },
      {
        title: column.Channel,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'channel',
        type: 'default'
      },
      {
        title: column.Source,
        classes: 'py-3 white-space-nowrap uppercase',
        sortable: false,
        filterable: true,
        dataProperty: 'source',
        type: 'default'
      },
      {
        title: column.Staff,
        classes: 'py-3 white-space-nowrap uppercase',
        dataProperty: 'created_by',
        type: 'component',
        data: { name: StaffInfoComponent },
      }
    ]);
  }

  closeDialogEvent() {
    this.clientHistoryModal = false;
    this.closeClientHistoryDialog.emit(true)
  }
  
}

